import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import MasterComponent from '../../../../../components/Forms';
import ShortListedConfig from '../../../../../entity/HRM/pre-onboarding/shortlistedConfig';
import { Button, Col, Dropdown, Flex, message, Modal, Rate, Row, Space, Tag, Typography } from 'antd';
import { ActionConfig, ColumnConfig, MasterConfigs } from '../../../../../interfaces/entity';
import NextRoundModal from '../Screening/modal';
import { DownOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons'
import { useDispatch } from 'react-redux';
import { putData } from '../../../../../actions/developer';
import CandidateResponse from './candidateResponse';
import { constants } from '../../../../../constants/common';
import Badge from '../../../../../components/Badge';
const { Text } = Typography;

const Candidates = () => {
  const level = constants.PROFILE_STATUS.CANDIDATES;
  const [nextRound, setNextRound] = useState(false)
  const [candidateType, setCandidateType] = useState(null)
  const [selected, setSelectedRow] = useState([])
  const [selectedURL, setSelectedURL] = useState(null)

  const dispatch = useDispatch();

  const items: any = [
    {
      label: "May be",
      key: 'May Be',
      color: 'blue'
    },
    {
      label: "Good",
      key: 'Good',
      color: 'green'
    },
    {
      label: "Not Fit",
      key: 'Not Fit',
      color: 'red'
    },
    {
      label: "Un Read",
      key: 'UnRead',
      color: 'yellow'
    },
  ];

  const onStatusChanged = async (e, profile) => {
    const resData = await dispatch(putData(ShortListedConfig.api() + '/' + level + '/' + profile._id, { profileStatus: e.key }))
    if (resData) {
      message.success('Successfully updated')
      onRefresh();
    } else {
      message.error('Something went wrong')
    }
  }

  const StatusChange = ({ profile, type = 'tag' }) => {
    const item = items.find(e => e.key == profile?.profileStatus);
    if (!item) {
      return <Tag color='red'>Unknown</Tag>
    }

    return <Dropdown
      menu={{
        items,
        onClick: (e) => onStatusChanged(e, profile)
      }}
      trigger={['click']}
    >
      {type == 'tag' ? <a onClick={(e) => e.preventDefault()}>
        <Space>
          <Badge text={item?.label} color={item?.color} />
        </Space>
      </a> : <Button >
        <Space>
          {item?.label}
          <DownOutlined />
        </Space>
      </Button>
      }
    </Dropdown >
  };

  const filter = (): ActionConfig => {
    return {
      actionType: 'filter',
      name: 'Filter'
    }
  }

  const onEdit = async (text, item, type = 'currentCTC') => {
    console.log("text, item,text, item,", text, item)
    let payload;
    if (type == 'currentCTC' && text != item?.currentCTC) {
      payload = { ...payload, currentCTC: text }
    }
    if (type == 'expectedCTC' && text != item?.expectedCTC) {
      payload = { ...payload, expectedCTC: text }
    }

    if (type == 'experiance' && text != item?.experiance) {
      payload = { ...payload, experiance: text }
    }

    if (type == 'noticePeriod' && text != item?.noticePeriod) {
      payload = { ...payload, noticePeriod: text }
    }

    if ((text != item?.currentCTC && type == 'currentCTC') || (text != item?.expectedCTC && type == 'expectedCTC')
      || (text != item?.expectedCTC && type == 'expectedCTC')
      || (text != item?.experiance && type == 'experiance')
      || (text != item?.noticePeriod && type == 'noticePeriod')) {
      const resData = await dispatch(putData(ShortListedConfig.api() + '/' + level + '/' + item?._id, payload));
      if (resData) {
        onRefresh()
      }
    }
  }

  const OverriddenConfig: MasterConfigs = {
    ...ShortListedConfig,
    api: () => ShortListedConfig.api() + '/' + level,
    tableProps: {
      rowSelection: {
        ...ShortListedConfig.rowSelection,
        onChange: (selectedRowKeys, selectedRows) => {
          setSelectedRow(selectedRows)
        },
      },
      scroll: { x: 1500 },
    },
    loadPagination: true,
    actions: [filter(), ...ShortListedConfig.actions, selected.length > 0 && { name: 'move to next', actionType: 'Add', onClick: () => onMoveToNext() }],
    getColumns: () => [
      ...ShortListedConfig.getColumns(),
      {
        title: 'Resume',
        dataIndex: '',
        key: '',
        width: 90,
        align: 'center',
        render: (text) => {
          return <Button type='link' icon={<EyeOutlined />} onClick={() => onViewModal(text)} />
        },
      },
      {
        title: 'Level',
        dataIndex: 'candidateType',
        key: 'candidateType',
        width: 100,
        align: 'center',
      },
      {
        title: 'Status',
        dataIndex: '',
        key: '',
        width: 120,
        fixed: 'right',
        align: 'center',
        render: (text) => {
          return <StatusChange profile={text} />
        },
      }
    ].filter(Boolean) as ColumnConfig[],
    getFormColumns: () => [
      ...ShortListedConfig.getFormColumns().map(ele => {
        if (ele.name == 'candidateType') {
          return {
            ...ele,
            selectProps: {
              onChange: (text) => {
                setCandidateType(text);
              }
            }
          }
        } else {
          if (ele.name == "experiance") {
            if (candidateType == 'Experience') {
              return ele
            } else {
              return
            }
          } else {
            return ele
          }
        }
      }
      ).filter(Boolean)
    ],
    getFilterColumns: () => {
      const baseFilters = ShortListedConfig.getFilterColumns ? ShortListedConfig.getFilterColumns() : [];
      return [
        ...baseFilters,
        {
          label: 'Status',
          name: 'profileStatus',
          type: 'select',
          span: 4,
          selectProps: {
            allowClear: true,
            placeholder: 'Select Status',
          },
          children: items.map(ele => {
            return {
              name: ele.label,
              value: ele.key
            }
          })
        }
      ];
    }
  };

  const onRefresh = () => {
    dispatch({
      type: 'REFRESH_TABLE',
      refreshTable: true
    })
  }

  const onViewModal = (item) => {
    const url = `${process.env.FILE_URL}${item?.resume}`
    setSelectedURL({ ...item, name: item?.firstName, url, skills: item?.skills });
  }

  const onMoveToNext = () => {
    setNextRound(true)
  }

  return <React.Fragment>
    <CandidateResponse selectedURL={selectedURL} setSelectedURL={setSelectedURL} />
    <NextRoundModal isVisible={nextRound} onClose={() => setNextRound(false)} selected={selected} level={level} />
    <MasterComponent config={OverriddenConfig} />
  </React.Fragment>
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.app.isAuthenticated,
  user: state.app.user,
});

export default connect(mapStateToProps)(Candidates);
